import { render, staticRenderFns } from "./trainCard.vue?vue&type=template&id=379b20bc&"
import script from "./trainCard.vue?vue&type=script&lang=ts&"
export * from "./trainCard.vue?vue&type=script&lang=ts&"
import style0 from "./trainCard.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports